const scrollEle = () => {
  const myFunc = function(){
    const target = document.getElementsByClassName('js-scroll');
    const position = Math.floor(window.innerHeight * .75);
    for (let i = 0; i < target.length; i++) {
        let offsetTop = Math.floor(target[i].getBoundingClientRect().top);
        if (offsetTop < position) {
            target[i].classList.add('is-scroll');
        } else {
            target[i].classList.remove('is-scroll');
        }
    }
  }
  window.addEventListener('scroll', myFunc, false);
}
